module.exports = __webpack_public_path__ + "img/Tek.4ded58e3.png";